import { FC } from 'react'

import styled from 'styled-components'

import { variables } from 'src/Styled/variables'
import { PlaylistCover } from 'src/Components/CuratorPlaylistsItem/PlaylistInfoItem/PlaylistCover'
import { numberFormatCommas } from 'src/Constants/functions'

const Container = styled.div`
  display: flex;
  padding: 8px 17px 8px 12px;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  align-self: stretch;
  border: 1px solid transparent;
  background: ${({ theme }) => theme.color.white};
  transition: border 0.2s ease-in-out;
  cursor: pointer;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

const PlaylistName = styled.span`
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Text = styled.span`
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const FollowersWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  line-height: 150%;
`

export interface ManualMatchingPlaylistItemProps {
  playlistName: string | undefined
  playlistCoverUrl?: string
  playlistUrl?: string
  followers?: number | string
}

export const ManualMatchingPlaylistItem: FC<
  ManualMatchingPlaylistItemProps
> = ({
  playlistName = 'Playlist name',
  playlistCoverUrl,
  playlistUrl,
  followers = '0',
}) => {
  const formattedFollowers = numberFormatCommas(Number(followers))
  const followersText = Number(followers) === 1 ? 'follower' : 'followers'

  return (
    <Container>
      <PlaylistCover coverUrl={playlistCoverUrl} playlistUrl={playlistUrl} />

      <InfoContainer>
        <PlaylistName>{playlistName}</PlaylistName>
        <FollowersWrapper>
          <Text>{formattedFollowers}</Text>
          <Text>{followersText}</Text>
        </FollowersWrapper>
      </InfoContainer>
    </Container>
  )
}
